<div class="logo" routerLink="" routerLinkActive="active" style="cursor: pointer;">
    <a class="simple-text logo-mini">
        <div class="logo-img">
            <img src="/assets/img/FL_white.png" />
        </div>
    </a>
    <a class="simple-text logo-normal">
        Fastlane
    </a>

</div>

<div class="sidebar-wrapper">
    <ul class="nav">
        <!-- Menu -->
        <li *ngFor="let menuitem of menuItems" routerLinkActive="active" class="nav-item">
            <!-- Se è un singolo link -->
            <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link'" class="nav-link collapsed"
                [class.network-disabled]="isNetworkDisabled(menuitem)"
                (click)="updatePS(menuitem.title)" id="{{'nav-' + menuitem.title }}">
                <i [ngClass]="menuitem.icontype"></i>
                <p>{{menuitem.title}}</p>
            </a>

            <!-- Se ha un sottomenu -->
            <a data-toggle="collapse" href="#{{menuitem.collapse}}" [hidden]="!menuitem.visible"
                *ngIf="menuitem.type === 'sub'" (click)="updatePS(menuitem.collapse)" id="{{'nav-' + menuitem.title }}"
                class="nav-link collapsed" [class.network-disabled]="isNetworkDisabled(menuitem)">
                <i [ngClass]="menuitem.icontype"></i>
                <p>{{menuitem.title}}<b class="caret"></b></p>
            </a>

            <!-- Visualizza i sottomenu -->
            <div [hidden]="!menuitem.visible" id="{{menuitem.collapse}}" class="collapse"
                *ngIf="menuitem.type === 'sub'">
                <ul class="nav sd">
                    <li routerLinkActive="active" *ngFor="let childitem of menuitem.children"
                        [hidden]="!childitem.visible" class="nav-item"
                        [class.network-disabled]="isNetworkDisabled(childitem)">
                        <a class="nav-link dropdown-toggle" id="dropdownMenuButton" role="button" data-toggle="dropdown"
                            aria-haspopup="false" aria-expanded="false"
                            [routerLink]="childitem.path ? [menuitem.path, childitem.path] : null"
                            class="nav-link" id="{{'nav-' + childitem.title }}">
                            <span class="sidebar-mini" id="miniSidebar">{{childitem.ab}}</span>
                            <span class="sidebar-normal">{{childitem.title}}</span>
                        </a>

                        <!-- Se l'elemento ha type === 'children-sub', usa dropdown -->
                        <div *ngIf="childitem.type === 'children-sub'">
                            <!-- Menu dropdown -->
                            <div class="dropdown-menu left65" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" [hidden]="!subChild.visible"
                                    *ngFor="let subChild of childitem.children"
                                    [class.network-disabled]="isNetworkDisabled(subChild)"
                                    [routerLink]="[menuitem.path, subChild.path]">
                                    {{subChild.title}}
                                </a>
                            </div>
                        </div>

                        <!-- Ricorsione per altri children -->
                        <ul class="nav sd" *ngIf="childitem.children && childitem.type !== 'children-sub'">
                            <li routerLinkActive="active" *ngFor="let subChild of childitem.children" class="nav-item">
                                <a [hidden]="!subChild.visible" [routerLink]="[menuitem.path, subChild.path]"
                                    class="nav-link" id="{{'nav-' + subChild.title }}"
                                    [class.network-disabled]="isNetworkDisabled(subChild)">
                                    <span class="sidebar-mini" id="miniSidebar">{{subChild.ab}}</span>
                                    <span class="sidebar-normal">{{subChild.title}}</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</div>